// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Committee } from './committee';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Agenda extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  agendaText?: string;
  committeeId?: number;
  created?: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  meetingDate!: Date;
  minutesText?: string;
  name?: string;
  committee!: Committee;
}

